/**
 * @file wq-compare.js
 * @description Product comparison feature — checkbox on product cards,
 *   floating "Compare (N)" bar, side-by-side spec comparison page.
 *   Max 4 products. Uses localStorage for persistence.
 * @sprint Design System | Phase 3.3
 */
window.WQ = window.WQ || {};

window.WQ.Compare = (() => {
  'use strict';

  var STORAGE_KEY = 'wq_compare_items';
  var MAX_ITEMS = 4;
  var barEl = null;

  function getItems() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }

  function saveItems(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) { /* quota exceeded */ }
  }

  function addItem(product) {
    var items = getItems();
    if (items.length >= MAX_ITEMS) return false;
    if (items.some(function(i) { return i.id === product.id; })) return false;
    items.push(product);
    saveItems(items);
    updateUI();
    return true;
  }

  function removeItem(productId) {
    var items = getItems().filter(function(i) { return i.id !== productId; });
    saveItems(items);
    updateUI();
  }

  function clearAll() {
    saveItems([]);
    updateUI();
  }

  function isInCompare(productId) {
    return getItems().some(function(i) { return i.id === productId; });
  }

  /** Create or update the floating compare bar */
  function updateUI() {
    var items = getItems();

    // Update all checkboxes on page
    var checkboxes = document.querySelectorAll('[data-wq-compare-toggle]');
    checkboxes.forEach(function(cb) {
      var pid = cb.getAttribute('data-wq-compare-toggle');
      cb.checked = isInCompare(pid);
    });

    // Floating bar
    if (!barEl) {
      barEl = document.createElement('div');
      barEl.className = 'wq-compare-bar';
      barEl.id = 'wq-compare-bar';
      document.body.appendChild(barEl);
    }

    if (items.length === 0) {
      barEl.style.display = 'none';
      return;
    }

    barEl.style.display = 'flex';
    var html =
      '<div class="wq-compare-bar__items">';

    for (var i = 0; i < items.length; i++) {
      html +=
        '<div class="wq-compare-bar__item">' +
          '<span class="wq-compare-bar__item-name">' + escapeHtml(items[i].title) + '</span>' +
          '<button class="wq-compare-bar__remove" data-remove="' + items[i].id + '" aria-label="Remove">&times;</button>' +
        '</div>';
    }

    html += '</div>' +
      '<div class="wq-compare-bar__actions">' +
        '<span class="wq-compare-bar__count">' + items.length + '/' + MAX_ITEMS + '</span>' +
        '<a href="/pages/compare" class="wq-compare-bar__btn wq-compare-bar__btn--compare"' +
          (items.length < 2 ? ' style="opacity:0.5;pointer-events:none"' : '') + '>Compare</a>' +
        '<button class="wq-compare-bar__btn wq-compare-bar__btn--clear">Clear</button>' +
      '</div>';

    barEl.innerHTML = html;

    // Bind remove buttons
    barEl.querySelectorAll('[data-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        removeItem(btn.getAttribute('data-remove'));
      });
    });

    // Bind clear button
    var clearBtn = barEl.querySelector('.wq-compare-bar__btn--clear');
    if (clearBtn) clearBtn.addEventListener('click', clearAll);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /** Initialize: bind checkboxes, create bar */
  function init() {
    // Bind existing compare checkboxes
    document.addEventListener('change', function(e) {
      var toggle = e.target.closest('[data-wq-compare-toggle]');
      if (!toggle) return;

      var pid = toggle.getAttribute('data-wq-compare-toggle');
      var title = toggle.getAttribute('data-wq-compare-title') || 'Product';

      if (toggle.checked) {
        var added = addItem({ id: pid, title: title });
        if (!added) {
          toggle.checked = false;
          alert('Maximum ' + MAX_ITEMS + ' products can be compared at once.');
        }
      } else {
        removeItem(pid);
      }
    });

    updateUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  return {
    addItem: addItem,
    removeItem: removeItem,
    clearAll: clearAll,
    getItems: getItems,
    isInCompare: isInCompare
  };
})();
